import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"

// Origin der einbettenden Seite (siehe frame-ancestors CSP in deployment/prod/helm-values.yml).
const PARENT_ORIGIN = "https://www.trekbars.com"

// #root statt document.body: body/html sind über min-height an die vom Parent
// gesetzte iframe-Höhe gekoppelt und würden beim Verkleinern nie schrumpfen.
const getContentHeight = () => document.getElementById("root")?.scrollHeight ?? document.documentElement.scrollHeight

const sendHeight = () => {
	window.parent.postMessage({ type: "iframe-height", height: getContentHeight() }, PARENT_ORIGIN)
}

const IframeHeightSender = () => {
	const location = useLocation()
	const isFirstRender = useRef(true)

	useEffect(() => {
		window.addEventListener("load", sendHeight)
		window.addEventListener("resize", sendHeight)

		const onMessage = (event: MessageEvent) => {
			if (event.data?.type === "request-iframe-height") sendHeight()
		}
		window.addEventListener("message", onMessage)

		const root = document.getElementById("root")
		const observer = new ResizeObserver(sendHeight)
		if (root) observer.observe(root)

		return () => {
			window.removeEventListener("load", sendHeight)
			window.removeEventListener("resize", sendHeight)
			window.removeEventListener("message", onMessage)
			observer.disconnect()
		}
	}, [])

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false
			sendHeight()
			return
		}
		window.parent.postMessage({ type: "route-change" }, PARENT_ORIGIN)
		sendHeight()
	}, [location.pathname])

	return null
}

export default IframeHeightSender
